"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewReport extends new_item_1.default {
    constructor(newReport) {
        super();
        if (!newReport.name) {
            throw Error("name required");
        }
        this.name = newReport.name;
        this.assetIds = newReport.assetIds;
        this.siteIds = newReport.siteIds;
        this.groupIds = newReport.groupIds;
        this.frequency = newReport.frequency;
        this.includeMegaPdf = newReport.includeMegaPdf;
        this.active = newReport.active;
        this.recipients = newReport.recipients;
        this.repeatOn = newReport.repeatOn;
        this.perDevice = newReport.perDevice;
        this._permission = newReport._permission;
    }
}
exports.default = NewReport;
//# sourceMappingURL=new-report.js.map